import { atomWithStorage } from 'jotai/utils';

export const cuaWakeAssertionEnabledAtom = atomWithStorage(
  'heidi:cua-wake-assertion-enabled',
  true,
  undefined,
  { getOnInit: true }
);

cuaWakeAssertionEnabledAtom.debugLabel = 'cuaWakeAssertionEnabledAtom';
